<template>
  <ObjectContactCard
    title="Coordonées de livraison"
    :object="modelValue"
    :editable="editable"
    :onSave="onSave" />
</template>

<script>

import ObjectContactCard from "@/components/cards/contactCards/ObjectContactCard.vue";

export default {
  name: "SaleContactCard",
  components: {
    ObjectContactCard,
  },
  props: {
    modelValue: { // The contact
      type: Object,
      required: false,
      default: null,
    },
    saleId: {
      type: Number,
      required: true,
    },
    editable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  methods: {
    onSave(newContact) {
      return new Promise((resolve, reject) => {
        this.$services.saleV2.patch(
          this.saleId,
          {
            contact: newContact,
          },
        ).then((response) => {
          this.$emit(
            "update:modelValue",
            response.data.contact,
          );
          resolve();
        }).catch((error) => {
          if (error.response && error.response.status === 400) {
            error.response.data = error.response.data.contact;
          }
          reject(error);
        });      
      });
    },
  },
};

</script>